import classNames from 'classnames';

import { StyledFormGroup, StyledRadioFormControl } from '@selfserve/react-ui';
import {
  billingCycles,
  billingCycleType,
  IIndexSignature,
  planType,
} from '@selfserve/react-utils';
import { PlanItem } from '@selfserve/react-common-data';

import { PlanType, Plans } from '../data';

interface Props {
  group_items: Array<PlanItem>;
  addons: IIndexSignature<PlanType>;
  addOnName: string;
  plans: Plans;
  billingCycle: string;
  handleRadioChange: (name: string, arr: Plans) => () => void;
}

export const AddonRadio = ({
  group_items,
  addons,
  addOnName,
  plans,
  billingCycle,
  handleRadioChange,
}: Props) => (
  <div>
    {group_items?.map(({ name, headline }, i, arr) => {
      const { plan_type, pricing_info } =
        plans?.find((p) => p.name === name) || {};
      const currentBillingCycle =
        billingCycle === billingCycles.ANNUALLY
          ? billingCycleType.YEAR
          : billingCycleType.MONTH;
      const price =
        (plan_type === planType.CHARGE
          ? pricing_info && pricing_info[0].price
          : pricing_info?.find((i) => i.billing_cycle === currentBillingCycle)
              ?.price) || 0;
      const checked = !!addons[name || ''];
      return (
        <StyledFormGroup rowWithLabel withPadding key={name}>
          <StyledRadioFormControl
            className={classNames('', { checked })}
            id={''}
            name={addOnName}
            value={price}
            checked={checked}
            onChange={handleRadioChange(name as string, arr)}
          />
          <label>
            <span>${price}</span>
            <span>{headline}</span>
          </label>
        </StyledFormGroup>
      );
    })}
  </div>
);
